import type { Database } from 'node-sqlite3-wasm';
import type { DbTagRow } from '../../resolution/types.js';
import type { SymbolImportBinding, SymbolTag } from '../../types.js';
import type { DbImportRow } from '../sqlite/symbol-index-import-sqlite.js';
import { loadFileImports, loadFileTags, type SymbolIndexParentContext } from '../storage/symbol-parent-file-map.js';
import type { SymbolIndexFileEntry } from './collect-file-entries.js';

function dbTagToSymbolTag(row: DbTagRow): SymbolTag {
  return {
    name: row.name,
    role: row.role as SymbolTag['role'],
    kind: row.kind,
    startLine: row.start_line,
    startColumn: row.start_column,
    endLine: row.end_line,
    endColumn: row.end_column,
    scopeStartLine: row.scope_start_line ?? undefined,
    scopeStartColumn: row.scope_start_column ?? undefined,
    parentScopeStartLine: row.parent_scope_start_line ?? undefined,
    parentScopeStartColumn: row.parent_scope_start_column ?? undefined,
    navTargetPath: row.nav_target_path ?? undefined,
    scopeChain: row.scope_chain ?? undefined,
  };
}

function dbImportToSymbolImport(row: DbImportRow): SymbolImportBinding {
  return {
    localName: row.local_name,
    sourceName: row.source_name,
    moduleSpecifier: row.module_specifier,
    sourceFilePath: row.source_file_path,
    importKind: row.import_kind as SymbolImportBinding['importKind'],
    startLine: row.start_line,
    startColumn: row.start_column,
  };
}

export function loadIndexedFileEntry(
  db: Database,
  ctx: SymbolIndexParentContext,
  relPath: string,
): SymbolIndexFileEntry | undefined {
  const tags = loadFileTags(db, ctx, relPath);
  const imports = loadFileImports(db, ctx, relPath);
  if (tags.length === 0 && imports.length === 0) return undefined;
  return {
    relPath,
    source: null,
    tags: tags.map(dbTagToSymbolTag),
    imports: imports.map(dbImportToSymbolImport),
  };
}
